/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ExportGipReportQueryResponse, ExportGipReportPathParams, ExportGipReportQueryParams, ExportGipReport400, ExportGipReport404 } from "../models/ExportGipReport";

export function getExportGipReportUrl(id: ExportGipReportPathParams["id"]) {
  const res = { method: 'GET', url: `/reports/gip/report/${id}/export` as const }
  return res
}

/**
 * @summary Export existing report
 * {@link /reports/gip/report/:id/export}
 */
export async function exportGipReport(id: ExportGipReportPathParams["id"], params: ExportGipReportQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ExportGipReportQueryResponse, ResponseErrorConfig<ExportGipReport400 | ExportGipReport404>, unknown>({ method : "GET", url : getExportGipReportUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}